import type { InputFieldStyleVariant } from "@components/common/InputField/types/inputfield";

/** Narrow card — sign-in and simple auth screens */
export const AUTH_SHELL_WIDTH_LOGIN = "w-full max-w-[520px]";

/** Wide card — sign-up (multi-column Institute-style layout) */
export const AUTH_SHELL_WIDTH_SIGNUP = "w-full max-w-[520px]";

/** Verify OTP — compact column (employer / committee OTP layout) */
export const AUTH_SHELL_WIDTH_VERIFY_OTP = "w-full max-w-[520px]";

/** OTP digits + submit — shared width so squares align with the CTA */
export const AUTH_OTP_FORM_COLUMN_CLASS = "mx-auto w-full max-w-[19rem] sm:max-w-[21rem]";

/** Institute-portal auth input sizing (padding drives control height) */
export const AUTH_INPUT_SIZE = {
	height: "10px",
	padding: "16px 20px",
} as const;

/** Auth field labels — 1rem (16px), semibold, gap above control */
export const AUTH_INPUT_LABEL_CLASS = "mb-3 block text-[1rem] font-semibold text-[#2f2f2f]";

/** Spread on auth `InputField` components — institute-portal sizing */
export const AUTH_INPUT_FIELD_PROPS = {
	inputStyleVariant: "auth" as InputFieldStyleVariant,
	size: AUTH_INPUT_SIZE,
	labelClassName: AUTH_INPUT_LABEL_CLASS,
} as const;

/** Profile modal fields — same control size as auth (placeholder-only, no labels) */
export const PROFILE_INPUT_FIELD_PROPS = {
	inputStyleVariant: "auth" as InputFieldStyleVariant,
	size: AUTH_INPUT_SIZE,
} as const;

/** Read-only profile rows — matches auth input padding and radius */
export const AUTH_READONLY_CONTROL_CLASS =
	"flex box-border items-center rounded-[10px] border border-[#D0D5DD] bg-white py-[16px] px-[20px] text-[13px] text-gray-700";

/** Flat auth shell — no card/modal surface; form sits on patterned panel */
export const AUTH_FORM_SHELL_CLASS =
	"w-full bg-transparent border-0 shadow-none p-0";

/** Auth page title block — centered on patterned background */
export const AUTH_FORM_HEADER_CLASS =
	"mb-8 space-y-2 text-center sm:mb-10";

/** Auth form body — transparent, no inner card */
export const AUTH_FORM_BODY_CLASS = "w-full pb-5";

/** Scrollable auth shell — vertically centered; header fixed, body scrolls when tall */
export const AUTH_SCROLLABLE_CARD_CLASS =
	"flex w-full max-h-[calc(100dvh-1.5rem)] flex-col overflow-hidden bg-transparent border-0 shadow-none p-0 sm:max-h-[calc(100dvh-2rem)]";

export const AUTH_SCROLLABLE_HEADER_CLASS =
	"shrink-0 mb-8 space-y-2 text-center sm:mb-10 [@media(max-height:700px)]:mb-6";

export const AUTH_SCROLLABLE_BODY_CLASS =
	"min-h-0 flex-1 overflow-y-auto overscroll-contain pb-5";

/** Left panel headline — institute AuthSplitLayout (see index.css .auth-left-headline-*) */
export const AUTH_LEFT_HEADLINE_SHELL_CLASS = "auth-left-headline-shell";

export const AUTH_LEFT_HEADLINE_LINE_CLASS = "auth-left-headline-line";

export const AUTH_LEFT_HEADLINE_LINE_TOP_CLASS = "auth-left-headline-line auth-left-headline-line--top";

export const AUTH_LEFT_HEADLINE_LINE_BOTTOM_CLASS = "auth-left-headline-line auth-left-headline-line--bottom";

/** Captcha image strip — full-width white field matching auth inputs */
export const AUTH_CAPTCHA_DISPLAY_CLASS =
	"flex h-[48px] min-h-[48px] flex-1 items-center justify-center rounded-[10px] border border-[#D0D5DD] bg-white px-3 [&>div]:flex [&>div]:min-w-0 [&>div]:flex-1 [&>div]:items-center [&>div]:justify-center [&_canvas]:block [&_canvas]:h-auto [&_canvas]:max-h-[44px] [&_canvas]:w-auto";
